import React from 'react';

import { AutocompleteField } from '../../src/components/form/AutocompleteField';
import { LeadCaptureSettingsResponse } from '../types/types';

type Props = {
  data: Partial<LeadCaptureSettingsResponse>;
};

export const SingleSelectQuestion = ({ data }: Props) => {
  const options =
    data.fields_to_capture_settings?.single_select_question?.answers
      ?.filter((answer) => answer.answer !== '')
      .sort((a, b) => a.order - b.order)
      .map((answer) => answer.answer) || [];

  return (
    <AutocompleteField
      label={data.fields_to_capture_settings?.single_select_question?.question || ''}
      name="single_select_question"
      options={options}
      ListboxProps={{ 'data-testid': 'lead-form-single-select' }}
      InputProps={{ 'data-testid': 'lead-form-single-select-input' }}
    />
  );
};
